import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
// @ts-ignore
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "moment/locale/ru";
import { CalendarEvent, DateRange } from "types/ui/calendar-item";
import { useSharedState } from "state";

export default function CalendarComponent({ data }: { data: CalendarEvent[] }) {
  const { currentRange, setCurrentRange, getCurrentRangeData } = useSharedState();

  const navigate = useNavigate();

  const userLocale = navigator.language;
  moment.locale(userLocale);
  const localizer = momentLocalizer(moment);

  useEffect(() => {
    getCurrentRangeData();
  }, []);

  const handleSelectEvent = (event: CalendarEvent) => {
    if (event.resource?.id) {
      navigate(`${event.resource.id}`);
    }
  };

  const eventStyleGetter = (event: CalendarEvent) => {
    return {
      style: {
        backgroundColor: event.resource?.color || "#004369",
        borderRadius: "4px",
      },
    };
  };

  const onRangeChange = (range: Date[] | DateRange) => {
    let newRange: { start: Date; end: Date };

    if (Array.isArray(range)) {
      newRange = {
        start: range[0],
        end: range[range.length - 1],
      };
    } else {
      newRange = range as { start: Date; end: Date };
    }

    const hasChanged =
      !currentRange.start ||
      !currentRange.end ||
      newRange.start.getTime() !== currentRange.start.getTime() ||
      newRange.end.getTime() !== currentRange.end.getTime();

    if (hasChanged) {
      setCurrentRange(newRange);
    }
  };

  return (
    <Calendar
      localizer={localizer}
      events={data}
      startAccessor="start"
      endAccessor="end"
      style={{ minHeight: 500 }}
      onSelectEvent={handleSelectEvent}
      eventPropGetter={eventStyleGetter}
      culture={userLocale}
      views={["month", "week", "day"]}
      messages={{
        today: "Текущий период",
        previous: "Предыдущий",
        next: "Следующий",
        month: "Месяц",
        week: "Неделя",
        day: "День",
      }}
      onRangeChange={onRangeChange}
    />
  );
}
